import CIMSFormItem from '../../../../../../../../../components/CIMSFormItem'
import CIMSSelect from '../../../../../../../../../components/CIMSSelect'
import { useOptions } from '../../../../../../../../../components/CIMSSelect/hooks/useOptions'
import { useDevelopersModuleContext } from '../../../../DevelopersModuleContext'

const UserFormItems: React.VFC = () => {
  const { users, loading } = useDevelopersModuleContext()
  return (
    <>
      <CIMSFormItem
        label="Users"
        help="Select one or more users to avoid clearing all users"
        name="userIds"
      >
        <CIMSSelect
          mode="multiple"
          simple
          options={useOptions({
            items: users,
            sort: 'username',
            label: 'username',
            value: 'id',
            tooltip: ({ username, mail }) =>
              username === mail ? undefined : mail,
          })}
          loading={loading}
        />
      </CIMSFormItem>
    </>
  )
}

export default UserFormItems
